import { css } from '@/styled-system/css';

export const drawerBodyStyles = css.raw({
  padding: 'default',
  overflowY: 'auto',
  flex: '1 1 auto',

  _focusVisible: {
    boxShadow: 'focus',
  },
});
